import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { AppLogo } from '../components/AppLogo.js';

export const PublicLayout: React.FC = () => {
  const isHome = useLocation().pathname === '/';
  return (
    <div className={`public-frame${isHome ? ' public-home' : ''}`}>
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <header className="public-header">
        <AppLogo />
        {isHome && (
          <nav className="home-section-nav" aria-label="Homepage sections">
            <a href="#cards">Cards</a>
            <a href="#services">Services</a>
            <a href="#faq">FAQ</a>
          </nav>
        )}
        <nav aria-label="Public navigation">
          <Link to="/login" className="quiet-link">
            Sign In
          </Link>
          <Link to="/register" className="ios-btn-primary">
            Get started
          </Link>
        </nav>
      </header>
      <main id="main-content" tabIndex={-1} className="public-content">
        <Outlet />
      </main>
      <footer className="public-footer">
        <span>© {new Date().getFullYear()} PAY888</span>

        {isHome ? (
          <nav aria-label="Footer navigation">
            <a href="#how-it-works">How it works</a>
            <a href="#faq">Help &amp; availability</a>
            <Link to="/login">Sign In</Link>
          </nav>
        ) : (
          <Link to="/preview">Explore the app ↗</Link>
        )}
      </footer>
    </div>
  );
};
